<template>
  <div>
    <Header
      :isactive="3"
      :ischunrk="true"
      :isfixed="true"
      :key="new Date().getTime()"
    />
    <div id="banner">
      <!-- {background:'url('+require('@/assets/image/banner-product.jpg')+') center center no-repeat'} -->
      <img src="@/assets/image/banner-product.jpg" alt="" />
    </div>
    <div id="product-server">
      <div class="server-content">
        <div class="title-content">
          <p class="trans">PRODUCT SERVICE</p>
          <p class="title">产品服务</p>
        </div>
        <ul class="ul-content">
          <!-- <li class="li-item first" @click="handleClick('')"> -->
          <li class="li-item first">
            <router-link :to="{ path: '/LCDPanel' }" target="_blank">
              <img class="bg-serve" src="@/assets/image/server-1-1.png" alt=""/>
              <div class="desc-content">
                <p class="title">液晶面板制造业</p>
                <p class="desc"></p>
                <div class="site-link">
                  <div class="go-to">
                    <img src="@/assets/image/go-to.png" alt="" />
                  </div>
                </div>
              </div>
            </router-link>
          </li>
          <li class="li-item">
            <router-link :to="{ path: '/CardManufacturing' }" target="_blank">
              <img class="bg-serve" src="@/assets/image/server-2.png" alt="" />
              <div class="desc-content">
                <p class="title">汽车制造业</p>
                <p class="desc"></p>
                <div class="site-link">
                  <div class="go-to">
                    <img src="@/assets/image/go-to.png" alt="" />
                  </div>
                </div>
              </div>
            </router-link>
          </li>
          <li class="li-item">
            <img class="bg-serve" src="@/assets/image/server-3.jpg" alt="" />
            <div class="desc-content">
              <p class="title">更多产品正在探索中</p>
              <p class="desc">敬请期待</p>
            </div>
          </li>
        </ul>
      </div>
    </div>
    <Footer />
    <Top />
  </div>
</template>

<script>
import Header from "@/components/Header/index.vue";
import Footer from "@/components/Footer/index.vue";
import Top from "@/components/Top/index.vue";

export default {
  components: { Header: Header, Footer: Footer, Top: Top },
  data() {
    return {};
  },
  watch: {
    $route(to) {
      this.autoScroll(to.query.href);
    }
  },
  mounted() {
    const _this = this;
    const _href = _this.$route.query.href;
    _this.autoScroll(_href);
    if (_href) {
      window.scrollTo(0, _href);
    } else {
      window.scrollTo(0, 0);
    }
  },
  methods: {
    handleClick(_val) {
      window.open(_val);
    },
    autoScroll(_href) {
      const _this = this;
      if (_href) {
        window.scrollTo(0, _href);
        _this.isScroll = _href;
      } else {
        window.scrollTo(0, 0);
      }
    }
  }
};
</script>
<style lang="scss" scoped>
$active: #40a9ff;
$width: 1200px;
$banner-height: 632px;
$font: 14px;
$trans: 0.25;
$opacity: 0.85;
$time-height: 110px;
$animateTime: 0.3s;

#banner {
  width: 100%;
  /* height: 482px; */

  img {
    width: 100%;
    display: block;
  }
}

#product-server {
  padding: 120px 0px;

  .server-content {
    width: $width;
    margin: 0 auto;

    .ul-content {
      margin-top: 60px;

      .li-item {
        margin-top: 32px;
        width: 100%;
        height: 356px;
        position: relative;
        cursor: pointer;
        overflow: hidden;

        .bg-serve {
          transform: scale(1);
          transition: all, $animateTime;
        }

        .desc-content {
          position: absolute;
          left: 0px;
          top: 0px;
          color: rgba(255, 255, 255, 0.85);
          padding-left: 80px;

          .title {
            font-size: 30px;
            font-weight: 500;
            line-height: 36px;
            margin: 80px 0px 16px;
          }

          .desc {
            width: 712px;
            font-size: 14px;
            line-height: 27px;
          }

          .site-link {
            margin-top: 40px;
            height: 32px;
            overflow: hidden;

            .a-link {
              float: left;
              font-size: 24px;
              line-height: 32px;
            }

            .go-to {
              float: left;
              width: 32px;
              height: 32px;
              margin-top: 4px;
              margin-left: 16px;
            }
          }
        }

        &:hover .bg-serve {
          transform: scale(1.024);
        }
      }

      .first {
        margin-top: 0px;
      }
    }
  }
}

.title-content {
  text-align: center;

  .title {
    font-size: 30px;
    height: 36px;
    margin-top: 4px;
    line-height: 36px;
  }

  .icon {
    margin: 10px auto;
    height: 2px;
    width: 24px;
    background: $active;
  }

  .trans {
    font-size: $font;
    opacity: $trans;
  }
}
</style>
